import React from 'react'

import { PartnersForm } from 'components/Partners'

import classes from './Form.module.scss'

export const FormWrapper: React.FC = () => {
  return (
    <div className={classes.wrapper}>
      <PartnersForm />
    </div>
  )
}
